import React, { PureComponent } from "react";

import { BrowserRouter as Router, Route,Redirect } from "react-router-dom";
import LeftSideMenu from 'components/LeftSideMenu';
import OpinionsMailbox from 'pages/comminicate/opinionsMailbox'
import DirectorMailbox from 'pages/comminicate/directorMailbox'
import SolicitOpinions from 'pages/comminicate/solicitOpinions'
import BusinessConsulting from 'pages/comminicate/businessConsulting'
import 'element-theme-default';
// require("./index.css");


export default class Comminicate extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dataList: [
        {
            txt: "网上征求意见信箱",
            type:1,
            component:OpinionsMailbox,
            path: '/entrance/comminicate/opinionsMailbox'
          },
          {
            txt: "厅长信箱",
            type:2,
            component:DirectorMailbox,
            path: '/entrance/comminicate/directorMailbox'
          },
          {
            txt: "征求意见",
            type:3,
            component:SolicitOpinions,
            path: '/entrance/comminicate/solicitOpinions'
          },
          {
            txt: "业务咨询",
            type:4,
            component:BusinessConsulting,
            path: '/entrance/comminicate/businessConsulting'
          }
      ]
    }
  }


  render() {
    
    return (
      <div>
        {/* 内容 */}
        <div className="content" style={{marginTop:1}}>
          <div className="container clear">
            <LeftSideMenu title={'互动交流'} data={this.state.dataList} tabListWidth={140}/>
            {
              this.state.dataList.map((item,index)=> {
                return(
                  <Route path={item.path} component={item.component} />
                )
              })
            }
              <Redirect from="/entrance/comminicate" to="/entrance/comminicate/opinionsMailbox" />
          </div>
        </div>
        {/* 内容 */}
      </div>
    );
  }
}
